
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#3F3F3F","d":"M.5.5h8.818v24H.5zm23.727 0h8.818v24h-8.818zm11.455 0H44.5v24h-8.818zM12.773.5h8v24h-8z"}})])
          )
        }
      }
    